import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Inline } from '@styleseat/ui';
import Analytics from '../../../../modules/analytics';
import { Button } from '../../../ui';

import './SeeReviewsLink.module.scss';
import {
  useLinkTo,
  useParams,
  useServiceInteractionCounter,
} from '../../../../hooks';
import { PROFILE_EDIT_ROUTE, PROFILE_ROUTE } from '../../../../route-names';

const SeeReviewsLink = ({
  provider,
  service,
  extra,
  isEditMode,
}) => {
  const currentRoute = useSelector(state => state?.route?.name);
  const params = useParams() || {};
  const linkTo = useLinkTo();
  const countInteraction = useServiceInteractionCounter();

  let linkPrefix = PROFILE_ROUTE;
  if (currentRoute === PROFILE_EDIT_ROUTE) {
    linkPrefix = PROFILE_EDIT_ROUTE;
  }
  const handleClick = () => {
    countInteraction(provider.id, service.id, isEditMode);
    // NOTE: If this event name changes, notify team Flywheel (FLY-2854) and data team (DT-1004)
    Analytics.track('client_servicereview_clicked', {
      provider_id_viewed: provider.id,
      service_id: service.id,
      service_name: service.name,
      is_top_service: service.isTopService,
      extra,
    });
    linkTo(`${linkPrefix}.service_info`, {
      providerId: params?.providerId || provider?.id,
      serviceId: service?.id,
    });
  };

  return (
    <Inline justifyContent="flex-start" testID="more_info_link">
      <Button
        appearance="link-accent-lowercase"
        onClick={handleClick}
        style={{ margin: 0 }}
        testID="see-reviews-link-button"
      >
        More Info
      </Button>
    </Inline>
  );
};

SeeReviewsLink.propTypes = {
  provider: PropTypes.object,
  service: PropTypes.object,
  extra: PropTypes.string,
  isEditMode: PropTypes.bool,
};

SeeReviewsLink.defaultProps = {
  provider: null,
  service: null,
  extra: undefined,
  isEditMode: false,
};

export default SeeReviewsLink;
